(function () {
  'use strict';

  var COOKIE_NAME = 'vat_display';
  var DEFAULT_MODE = 'inc'; 
  var BODY_CLASS_INC = 'vat-show-inc';
  var BODY_CLASS_EX  = 'vat-show-ex';


  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length);
      }
    }
    return null;
  }


  function getInitialMode() {
    var saved = getCookie(COOKIE_NAME);
    if (saved === 'inc' || saved === 'ex') return saved;
    return DEFAULT_MODE;
  }

  function applyMode(mode) {
    var body = document.body;

    if (mode === 'ex') {
      body.classList.add(BODY_CLASS_EX);
      body.classList.remove(BODY_CLASS_INC);
    } else {
      body.classList.add(BODY_CLASS_INC);
      body.classList.remove(BODY_CLASS_EX);
    }

    var tracks = document.querySelectorAll('.vat-slider-track');
    tracks.forEach(function (track) {
      track.setAttribute('aria-checked', mode === 'ex' ? 'true' : 'false');
    });


    document.querySelectorAll('[data-vat-label]').forEach(function (label) {
      label.classList.toggle('is-active', label.getAttribute('data-vat-label') === mode);
    });

    setCookie(COOKIE_NAME, mode, 0);

    document.dispatchEvent(new CustomEvent('vatModeChanged', {
      detail: { mode: mode },
      bubbles: true
    }));
  }

  function onToggleClick(e) {
    var track = e.target.closest('.vat-slider-track');
    if (!track) return;
    var currentMode = getCookie(COOKIE_NAME) || DEFAULT_MODE;
    applyMode(currentMode === 'inc' ? 'ex' : 'inc');
  }

  function attachListeners() {
    document.addEventListener('click', onToggleClick);
  }


  function watchDynamicContent() {
    var observer = new MutationObserver(function (mutations) {
      var hasNewPrices = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (!hasNewPrices) return;

      var currentMode = getCookie(COOKIE_NAME) || DEFAULT_MODE;
      applyMode(currentMode);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }


  document.addEventListener('shopify:section:load', function () {
    var currentMode = getCookie(COOKIE_NAME) || DEFAULT_MODE;
    applyMode(currentMode);
  });


  document.addEventListener('cart:updated', function () {
    var currentMode = getCookie(COOKIE_NAME) || DEFAULT_MODE;
    applyMode(currentMode);
  });

  document.addEventListener('cart:open', function () {
    var currentMode = getCookie(COOKIE_NAME) || DEFAULT_MODE;
    applyMode(currentMode);
  });

  function init() {
    var mode = getInitialMode();
    applyMode(mode);

    attachListeners();

    watchDynamicContent();
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

})();